import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const propTypes = {
  /**
   * Additional custom classes for the Radio
   **/
  className: PropTypes.string,
  /**
   * Display as bordered style
   */
  hasBorder: PropTypes.bool,
  /**
   * The Radio's ID
   */
  id: PropTypes.string.isRequired,
  /**
   * Marks the radio input as selected
   */
  isChecked: PropTypes.bool,
  /**
   * Is the Radio disabled
   */
  isDisabled: PropTypes.bool,
  /**
   * The label text of the Radio
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  /**
   * The HTML name attribute value for the radio button input element
   */
  name: PropTypes.string.isRequired,
  /**
   * Function that runs when a radio is clicked
   * * (e: Event) => void
   */
  onChange: PropTypes.func,
  /**
   * The value returned by the Radio
   */
  value: PropTypes.string.isRequired
};
const defaultProps = {
  className: '',
  hasBorder: false,
  id: '',
  isChecked: false,
  isDisabled: false,
  label: '',
  name: '',
  onChange: null,
  value: ''
};
const Radio = props => {
  const {
    className,
    hasBorder,
    id,
    isChecked,
    isDisabled,
    label,
    name,
    onChange,
    value,
    ...radioPassthrough
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classNames('asc-radio-group asc-mtb-1', className, {
      'asc-radio-group--bordered': hasBorder
    })
  }, /*#__PURE__*/React.createElement("label", {
    className: "asc-form-label asc-m-0",
    htmlFor: id
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "radio",
    id: id,
    disabled: isDisabled,
    name: name,
    checked: isChecked,
    value: value,
    onChange: onChange
  }, radioPassthrough)), typeof label === 'string' ? /*#__PURE__*/React.createElement("span", {
    className: "asc-form-label-text"
  }, label) : label)));
};
Radio.defaultProps = defaultProps;
Radio.propTypes = propTypes;
export default Radio;